import http from '@core/fetch'
export default {
  chatActiveApi: () => http.post('/p/wedding/Admin/APIMerchantChatlink/active'),
  chatCheckApi: () => http('/p/wedding/Admin/APIMerchantChatlink/check'),
  templateApi: () => http('/p/wedding/Admin/APIMerchantChatlink/template'),
  chatEditApi: body =>
    http.post('/p/wedding/Admin/APIMerchantChatlink/edit', { body })
}
